module.exports = __webpack_public_path__ + "img/add_photo_alternate.30531266.svg";